module.exports = flarum.core.compat['components/TextEditor'];